import axios, { AxiosError } from "axios";
import { useAuthStore } from "@/_stores/useAuthStore";
import axiosRetry from "axios-retry";

const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const mainApiInstance = axios.create({
  baseURL: BASE_URL,
});

axiosRetry(mainApiInstance, {
  retries: 2,
  retryCondition: (error: AxiosError) => {
    const axiosStatus = error.response?.status;
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) ||
      axiosStatus === 429 ||
      (axiosStatus !== undefined && axiosStatus >= 500 && axiosStatus <= 504)
    );
  },
  retryDelay: (retryCount: number) => {
    console.log("retryDelay", retryCount);
    const delay = retryCount * 1000;
    const jitter = Math.random() * 200;
    return delay + jitter;
  },
});

mainApiInstance.interceptors.request.use(async (config) => {
  const auth = useAuthStore.getState().getAuth();
  if (auth?.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
});

export { mainApiInstance };
